export default "__VITE_ASSET__BA6PfJz0__"